import { useState, useCallback } from 'react';

/**
 * Custom hook for managing undo history
 * @returns {Object} Undo history state and handlers
 */
const useUndoHistory = () => {
  // History stack stores actions that can be undone
  const [history, setHistory] = useState([]);
  
  /**
   * Add an action to the history stack
   * @param {Object} action - Action to add to history
   * @param {string} action.type - Type of action (e.g., 'ADD_BOX', 'ADD_SHAPE', 'DELETE_SPACE')
   * @param {Object} action.data - Data needed to undo the action
   */
  const addToHistory = useCallback((action) => {
    setHistory(prevHistory => [...prevHistory, action]);
  }, []);
  
  /**
   * Undo the most recent action
   * @returns {Object|null} The action that was undone, or null if no actions to undo
   */
  const undo = useCallback(() => {
    if (history.length === 0) {
      console.log('Nothing to undo');
      return null;
    }
    
    // Get the most recent action
    const newHistory = [...history];
    const actionToUndo = newHistory.pop();
    
    // Update history
    setHistory(newHistory);
    
    console.log('Undoing action:', actionToUndo);
    return actionToUndo;
  }, [history]);
  
  /**
   * Clear the history stack
   */
  const clearHistory = useCallback(() => {
    setHistory([]);
  }, []);
  
  return {
    history,
    addToHistory,
    undo,
    clearHistory
  };
};

export default useUndoHistory; 